/** Bảng nhân viên M3: thuê thu ngân / xếp kệ (không cấp nhân viên). */
import { layThamSo } from '../../core/du-lieu.js';
import type { GameController } from '../game-controller.js';
import { dinhDangXu, styleNutChinh, stylePanel, useCapNhat } from '../dung-chung.js';
import { toast } from './Toast.js';

export function PanelNhanVien(props: { controller: GameController }) {
  const { controller } = props;
  useCapNhat(controller);
  const { state, duLieu } = controller;

  const bamThue = (vai: 'thuNgan' | 'xepKe'): void => {
    try {
      controller.thueNhanVien(vai);
      toast(vai === 'thuNgan' ? 'Đã thuê thu ngân! 🎉' : 'Đã thuê nhân viên xếp kệ! 🎉');
    } catch (e) {
      toast(e instanceof Error ? e.message : 'Không thuê được.');
    }
  };

  const cacVai: {
    vai: 'thuNgan' | 'xepKe';
    ten: string;
    moTa: string;
    maPhi: string;
  }[] = [
    { vai: 'thuNgan', ten: 'Thu ngân', moTa: 'Tính tiền nhanh, khách hài lòng hơn.', maPhi: 'P37' },
    { vai: 'xepKe', ten: 'Nhân viên xếp kệ', moTa: 'Giữ kệ luôn đầy, ít hết hàng.', maPhi: 'P38' },
  ];

  return (
    <div style={stylePanel}>
      <h3 style={{ margin: '0 0 8px' }}>🧑‍💼 Nhân viên</h3>
      <p style={{ margin: '0 0 10px', fontSize: '13px', opacity: 0.85 }}>
        Nhân viên không lên cấp. Lương trả mỗi giờ game (offline tính 30%). Nhân viên xuất hiện
        trong cửa hàng.
      </p>
      {cacVai.map(({ vai, ten, moTa, maPhi }) => {
        const tt = vai === 'thuNgan' ? duLieu.luong.thuNgan : duLieu.luong.xepKe;
        const daThue = vai === 'thuNgan' ? state.nhanVien.thuNgan : state.nhanVien.xepKe;
        const phi = layThamSo(duLieu, maPhi);
        return (
          <div
            key={vai}
            style={{
              border: '1px solid #8a6a3a',
              borderRadius: '8px',
              padding: '8px',
              marginBottom: '8px',
            }}
          >
            <div style={{ fontWeight: 700 }}>
              {ten} {daThue ? '✅' : ''}
            </div>
            <div style={{ fontSize: '13px', opacity: 0.85 }}>{moTa}</div>
            <div style={{ fontSize: '13px', marginTop: '4px' }}>
              {daThue ? (
                <span>Lương: {dinhDangXu(tt.luongMoiGioGame)}/giờ game</span>
              ) : (
                <span>
                  Cần cửa hàng cấp {tt.capThue} — phí thuê một lần {dinhDangXu(phi)}, lương{' '}
                  {dinhDangXu(tt.luongMoiGioGame)}/giờ game
                </span>
              )}
            </div>
            {!daThue && (
              <button onClick={() => bamThue(vai)} style={`${styleNutChinh}margin-top:6px;`}>
                Thuê ({dinhDangXu(phi)})
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}
